export default __webpack_public_path__ + "static/media/Footer.0d0fea49.png";